var Segment;
(function (Segment) {
    Segment["WOMEN"] = "WOMEN";
    Segment["MEN"] = "MEN";
})(Segment || (Segment = {}));
export { Segment };
